import { motion } from 'framer-motion';
import AnimatedPage from '../components/AnimatedPage';

const Disclaimer = () => {
  return (
    <AnimatedPage>
      <div className="min-h-screen pt-20 pb-12">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="heading-1 mb-6">Disclaimer</h1>
            <div className="w-20 h-1 bg-black mb-8" />
            <p className="text-gray-600 font-body mb-8">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div className="space-y-8 font-body">
              <section>
                <h2 className="heading-3 mb-4">Website Disclaimer</h2>
                <p className="text-gray-700 leading-relaxed">
                  The information provided by RaiBlog ("we," "us," or "our") on this website is for general informational 
                  purposes only. All information on the site is provided in good faith, however we make no representation 
                  or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, 
                  availability, or completeness of any information on the site.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">No Professional Advice</h2>
                <p className="text-gray-700 leading-relaxed">
                  The content on RaiBlog is not intended to be a substitute for professional advice, diagnosis, or 
                  treatment. Always seek the advice of qualified professionals with any questions you may have regarding 
                  any matter discussed on this website. Never disregard professional advice or delay in seeking it because 
                  of something you have read on RaiBlog.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">External Links Disclaimer</h2>
                <p className="text-gray-700 leading-relaxed">
                  RaiBlog may contain links to external websites that are not provided or maintained by or in any way 
                  affiliated with us. Please note that we do not guarantee the accuracy, relevance, timeliness, or 
                  completeness of any information on these external websites. We are not responsible for the content of 
                  external sites or for any damages or losses arising from your use of them.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Affiliate Links</h2>
                <p className="text-gray-700 leading-relaxed">
                  RaiBlog may contain affiliate links. This means that we may receive a commission if you click on a link 
                  and make a purchase. However, this does not impact our reviews and comparisons. We try to keep things 
                  fair and balanced to help you make the best choice for you.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Advertisement Disclaimer</h2>
                <p className="text-gray-700 leading-relaxed">
                  We use Google AdSense to display advertisements on RaiBlog. These advertisements are provided by 
                  third-party advertisers and we are not responsible for the content, accuracy, or opinions expressed in 
                  such advertisements. The appearance of advertisements on our website does not constitute an endorsement 
                  or recommendation by us.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Testimonials Disclaimer</h2>
                <p className="text-gray-700 leading-relaxed">
                  RaiBlog may contain testimonials by users of our products and/or services. These testimonials reflect 
                  the real-life experiences and opinions of such users. However, the experiences are personal to those 
                  particular users, and may not necessarily be representative of all users. We do not claim, and you should 
                  not assume, that all users will have the same experiences.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Errors and Omissions</h2>
                <p className="text-gray-700 leading-relaxed">
                  While we strive to provide accurate and up-to-date information, RaiBlog makes no representations or 
                  warranties of any kind about the completeness, accuracy, reliability, suitability, or availability with 
                  respect to the website or the information, products, services, or related graphics contained on the 
                  website for any purpose.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Fair Use</h2>
                <p className="text-gray-700 leading-relaxed">
                  This site may contain copyrighted material, the use of which may not have been specifically authorized 
                  by the copyright owner. We believe this constitutes fair use of any such copyrighted material as provided 
                  for in section 107 of the US Copyright Law. If you wish to use copyrighted material from this site for 
                  purposes that go beyond fair use, you must obtain permission from the copyright owner.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Views Expressed</h2>
                <p className="text-gray-700 leading-relaxed">
                  The views and opinions expressed on RaiBlog are those of the authors and do not necessarily reflect the 
                  official policy or position of any other agency, organization, employer, or company. Any content provided 
                  by our bloggers or authors are of their opinion and are not intended to malign any religion, ethnic group, 
                  club, organization, company, individual, or anyone or anything.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Consent</h2>
                <p className="text-gray-700 leading-relaxed">
                  By using our website, you hereby consent to our disclaimer and agree to its terms.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Updates</h2>
                <p className="text-gray-700 leading-relaxed">
                  Should we update, amend, or make any changes to this document, those changes will be prominently posted 
                  here with an updated revision date.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Contact Us</h2>
                <p className="text-gray-700 leading-relaxed">
                  If you have any questions or concerns about this disclaimer, please feel free to contact us through our{' '}
                  <a href="/contact" className="text-black underline hover:no-underline">Contact page</a>.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </div>
    </AnimatedPage>
  );
};

export default Disclaimer;
